export const ArrowIcon4 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M20 0H19.894C15.5981 0 12.2326 1.10892e-07 9.60558 0.353488C6.91907 0.714419 4.79814 1.46977 3.13302 3.13302C1.46791 4.79814 0.714419 6.91907 0.353488 9.60744C1.10892e-07 12.2326 0 15.5981 0 19.894V20.106C0 24.4019 1.10892e-07 27.7674 0.353488 30.3944C0.714419 33.0809 1.46977 35.2019 3.13302 36.867C4.79814 38.5321 6.91907 39.2856 9.60744 39.6465C12.2326 40 15.5981 40 19.894 40H20.106C24.4019 40 27.7674 40 30.3944 39.6465C33.0809 39.2856 35.2019 38.5302 36.867 36.867C38.5321 35.2019 39.2856 33.0809 39.6465 30.3926C40 27.7674 40 24.4019 40 20.106V20C40 19.6299 39.853 19.275 39.5913 19.0133C39.3296 18.7517 38.9747 18.6047 38.6047 18.6047C38.2346 18.6047 37.8797 18.7517 37.618 19.0133C37.3563 19.275 37.2093 19.6299 37.2093 20C37.2093 24.4242 37.2056 27.6019 36.8819 30.0205C36.5619 32.4 35.9516 33.8344 34.893 34.8949C33.8326 35.9535 32.4 36.5619 30.0205 36.8819C27.6019 37.2056 24.4242 37.2093 20 37.2093C15.5758 37.2093 12.3981 37.2056 9.97954 36.8819C7.6 36.5619 6.16558 35.9516 5.10512 34.893C4.04651 33.8326 3.43814 32.4 3.11814 30.0205C2.79442 27.6019 2.7907 24.4242 2.7907 20C2.7907 15.5758 2.79442 12.3981 3.11814 9.97954C3.43814 7.6 4.04837 6.16558 5.10698 5.10512C6.16744 4.04651 7.6 3.43814 9.97954 3.11814C12.3981 2.79442 15.5758 2.7907 20 2.7907C20.3701 2.7907 20.725 2.64369 20.9867 2.38201C21.2483 2.12033 21.3953 1.76542 21.3953 1.39535C21.3953 1.02528 21.2483 0.670367 20.9867 0.408688C20.725 0.14701 20.3701 5.51447e-09 20 0Z"
      fill="url(#paint0_linear_1501_315)"
    />
    <path
      d="M37.6351 4.40675C37.8753 4.13546 38.006 3.77663 37.9998 3.40587C37.9936 3.03512 37.8509 2.68137 37.6018 2.41917C37.3527 2.15696 37.0166 2.00676 36.6644 2.00022C36.3122 1.99368 35.9713 2.1313 35.7136 2.3841L21.7191 17.1151V10.3698C21.7191 9.9902 21.5759 9.62619 21.3209 9.3578C21.066 9.08941 20.7201 8.93863 20.3596 8.93863C19.999 8.93863 19.6532 9.08941 19.3982 9.3578C19.1432 9.62619 19 9.9902 19 10.3698V20.5689C19 21.3589 19.6091 22 20.3596 22H30.0469C30.4075 22 30.7533 21.8492 31.0083 21.5808C31.2632 21.3124 31.4065 20.9484 31.4065 20.5689C31.4065 20.1893 31.2632 19.8253 31.0083 19.5569C30.7533 19.2885 30.4075 19.1378 30.0469 19.1378H23.6407L37.6351 4.40675Z"
      fill="url(#paint1_linear_1501_315)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1501_315"
        x1="-0.821917"
        y1="20"
        x2="19.693"
        y2="-0.410693"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000" />
        <stop offset="1" stopColor="#000" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1501_315"
        x1="18.6096"
        y1="12"
        x2="28.8509"
        y2="2.32019"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#000" />
        <stop offset="1" stopColor="#000" />
      </linearGradient>
    </defs>
  </svg>
);
